<gl-pro-modal (closeModal)="close(false)">
  <p class="message">
    {{ 'subscription_end_message_1' | translate }} <strong>{{ endDatePro }}</strong>.
    {{ 'subscription_end_message_2' | translate }}<br />
    <a pro-link (click)="openPriceList()" class="proLink">{{'generate_ivnoice' | translate}}</a>
  </p>
</gl-pro-modal>
